module.exports = __webpack_public_path__ + "static/media/CODEQUEST6.3daba225.pdf";